var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1409_29489)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 28,
    height: 28,
    rx: 6,
    fill: "#136B00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint0_linear_1409_29489)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 27,
    height: 27,
    rx: 5.5,
    stroke: "url(#paint1_linear_1409_29489)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20C14.6739 20 13.4021 19.4732 12.4645 18.5355C11.5268 17.5979 11 16.3261 11 15C11 13.6739 11.5268 12.4021 12.4645 11.4645C13.4021 10.5268 14.6739 10 16 10C17.3261 10 18.5979 10.5268 19.5355 11.4645C20.4732 12.4021 21 13.6739 21 15C21 16.3261 20.4732 17.5979 19.5355 18.5355C18.5979 19.4732 17.3261 20 16 20ZM16.8525 13.1475L15.5075 15.7162L14.5431 14.8475C14.4821 14.7926 14.4109 14.7502 14.3335 14.7229C14.2561 14.6955 14.1741 14.6836 14.0921 14.6879C14.0101 14.6923 13.9298 14.7127 13.8557 14.7481C13.7816 14.7834 13.7152 14.833 13.6603 14.8941C13.6054 14.9551 13.5631 15.0263 13.5357 15.1037C13.5083 15.1811 13.4964 15.2631 13.5008 15.3451C13.5051 15.4271 13.5255 15.5074 13.5609 15.5815C13.5962 15.6556 13.6459 15.722 13.7069 15.7769L15.2694 17.1831C15.3402 17.2469 15.4246 17.2936 15.5162 17.3197C15.6078 17.3459 15.7042 17.3507 15.798 17.3339C15.8918 17.3171 15.9805 17.279 16.0573 17.2227C16.1341 17.1663 16.197 17.0931 16.2413 17.0087L17.96 13.7275C18.0369 13.5806 18.0523 13.4092 18.0029 13.251C17.9534 13.0928 17.8431 12.9607 17.6962 12.8838C17.5494 12.8068 17.378 12.7914 17.2198 12.8409C17.0615 12.8903 16.9294 13.0006 16.8525 13.1475Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1409_29489",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1409_29489"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.419608 0 0 0 0 0 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1409_29489"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.419608 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1409_29489",
    result: "effect2_dropShadow_1409_29489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1409_29489",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1409_29489",
    x1: 16,
    y1: 1,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1409_29489",
    x1: 16,
    y1: 1,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBtn);
export default __webpack_public_path__ + "static/media/checkBtn.d34d215ee9860186d985ba246e093aa8.svg";
export { ForwardRef as ReactComponent };